const lng = {
  navbar: {
    home: 'Home',
    about: 'About',
    projects: 'Projects',
    gaming: 'Gaming',
    news: 'News',
    tools: 'Tools',
  },
  components: {
    generic: {
      day: 'day(s)',
      week: 'week(s)',
      month: 'month',
      year: 'year(s)',
      hour: 'hour(s)',
      minute: 'minute(s)',
      second: 'second(s)',
    },
    form: {
      save: 'Send',
      cancel: 'Cancel',
      confirm: 'Confirm',
    },
    atoms: {
      alert: {
        wip: 'This functionality is in work in progress !',
        info: 'Info',
        error: 'Error',
        success: 'Success',
        changesSaved: 'All changes have been saved.',
        errorTryLater: 'Error ! Please try again later.',
        copied: 'Text have been copied !',
      },
      select: {
        noOptions: 'No element',
        loading: 'Loading',
      },
    },
    layout: {
      footer: {
        source: 'See Source',
      },
      available: 'I am currently available for a new mission ! Contact me !',
    },
  },
  pages: {
    error: {
      notFound: {
        title: 'Page not found !',
        action: 'Go to homepage',
      },
    },
    home: {
      Im: "I'm",
      jobTitle: "I'm a Lead Developer and Full-Stack JS Developer (Node, React) at {{company}}",
      freelanceInfo: 'Passionate, freelance developer, I create projects and launch your ideas 🚀',
      moreAbouteMe: 'More about me',
      contactMe: 'Contact me',
    },
    cv: {
      fullStack: 'Full Stack JS Developer',
      leadDev: 'Lead Developer',
      address: 'Address',
      contact: 'Contact',
      formation: 'Education & Diplomas',
      experiences: 'Professional experiences',
      since: 'Since',
      about: 'About',
      priorities: 'My priorities',
      prioritiesDetails: {
        projectManagement: 'Clear project management',
        qualityCode: 'Reusable, Clean & Documented code',
        tests: 'Unit / Functional tests',
        cicd: 'CI / CD process to reduce DX pain',
        client: 'Focus on customer / product experience',
        security: 'Focus on security',
        news: 'Continuous technological search',
      },
      downloadEN: 'Download (EN)',
      downloadFR: 'Download (FR)',
    },
    about: {
      title: 'About',
      description: "Here's my story",
      presentation: {
        '1': "I'm Quentin, a <u>Lead Dev / Full Stack JS developer</u> specialized to ensure quality of your projects and who make your <u>developer and user life easier</u>. My mission is to translate user needs on website and applications that run blazing fast but with a great developer experience.",
        '2': "I'm currently working as a {{jobTitle}} at <u>{{company}}</u>. I work hard on my tasks to help tech team in every aspects : Tech Stack, Dev Practices, Product Management, Testing, Deployment, etc.",
        '3': "As a Freelance, I do the same thing with a customer level of expertise. <u>I'm focusing on delivery, quality and advices on your online strategy</u>. With my SEO/SEA expertise, I can advice you some strategies to make you website as we can on 1st page of Google.",
        '4': 'You can find me on my Discord where sometimes I share my thoughts about my work and my life. On my Github (@qlaffont), you can found some of my open source libraries / projects. On my Discord server, you can contact me and sometimes I share some advices / tech news that I think are interesting.',
      },
      cv: 'Download Resume',
      experiences: 'My experiences',
      diplomas: 'My diplomas',
      services: 'Services',
      servicesDetails: {
        website: {
          title: 'Website',
          description:
            'Do you need a new website ? You want a static website, you want to be connected to a CMS like Wordpress, you want to have a theme and code your website ? I have what you need and what you are waiting for !',
        },
        application: {
          title: 'Application',
          description:
            'You need to build a application to make your workflow easier, you need to create an e-commerce solution ? We can do it !',
        },
        discord: {
          title: 'Discord bot',
          description:
            "I love Discord ! Probably like you ! But you want to connect your application, your data and your services (like Stripe, Chargebee, Twitch, Github, Trello, etc.) on your company server, but you don't know how to do it ? I can do it !",
        },
      },
      servicesHero: {
        title: "Let's work together !",
        description: 'Send me an email with all details and I will try to answer you in 48 h !',
      },
    },
    gaming: {
      title: 'Gaming',
      description: "Here's my other side",
      experiences: 'My experiences',
      twitch: 'See on Twitch',
      donation: 'Donation',
    },
    projects: {
      title: 'Projects',
      description: 'Some recent works',
    },
    news: {
      title: 'News / Conferences',
      description: 'Some articles and presentations',
      moreNews: 'More Articles',
      presentations: 'Presentations',
    },
    tools: {
      title: 'Tools & Config',
      description: 'My tools and my PCs',
      config: {
        desktop: 'Desktop PC',
        portable: 'Portable PC',
        os: 'OS',
        processor: 'Processor',
        motherboard: 'Motherboard',
        alimentation: 'Alimentation',
        cooler: 'Cooler',
        case: 'Case',
        graphicCard: 'Graphic Card',
        ram: 'RAM',
        keyboardAndMouse: 'Keyboard & Mouse',
        keyboard: 'Keyboard',
        headset: 'Headset & Mic',
        flight: 'Sim Flight',
        driving: 'Sim Racing',
      },
    },
  },
};

export default lng;
